module.exports = __webpack_public_path__ + "static/media/failed-bg.9d121f7f.svg";